import Axios from 'axios';

import { IdelinkGlobalConstants } from '../../../IdelinkGlobalConstants';
import {
	ClientConfig,
	ConfigFactory,
	ElasticSearchConfig,
	EnvironmentConfig,
	getGoogleMapApiKey,
	getLogsConfig,
	getRoot,
} from '../../../libs/IdeLink.Web.Common/src/configs/ApiConfig';

export class OxylinkApiConfig {
	public static CLIENT_ID = 'OXYLINK_WEB_BACK';

	public static API_URL_PRODUCTION = '__OXYLINK_API_HOST__';
	public static API_URL_DEVELOPMENT = 'https://oxylink-api-dev.azurewebsites.net/';

	public static GOOGLE_MAP_API_KEY_PRODUCTION = '__OXYLINK_GOOGLE_MAP_API_KEY__';

	public static ES_INDEX_PRODUCTION = '__ELASTIC_SEARCH_INDEX__';
	public static ES_INDEX_DEVELOPMENT = 'oxylink-bo-local';

	public static ClientConfig: ClientConfig = {
		id: OxylinkApiConfig.CLIENT_ID,
		secret: IdelinkGlobalConstants.CLIENT_SECRET,
	};

	public static EsLogsConfig: ElasticSearchConfig = {
		...IdelinkGlobalConstants.LOGS,
		elasticSearchIndex: {
			development: OxylinkApiConfig.ES_INDEX_DEVELOPMENT,
			production: OxylinkApiConfig.ES_INDEX_PRODUCTION,
		},
	};

	public static ApiUrlConfig: EnvironmentConfig = {
		development: OxylinkApiConfig.API_URL_DEVELOPMENT,
		production: OxylinkApiConfig.API_URL_PRODUCTION,
	};

	public static GoogleMapApiKeyConfig: EnvironmentConfig = {
		development: IdelinkGlobalConstants.GOOGLE_MAP_API_KEY_DEVELOPMENT,
		production: OxylinkApiConfig.GOOGLE_MAP_API_KEY_PRODUCTION,
	};

	public static initApiConfig = () => {
		ConfigFactory.getRoot.register('**', () => getRoot(OxylinkApiConfig.ApiUrlConfig));
		Axios.defaults.baseURL = getRoot(OxylinkApiConfig.ApiUrlConfig);

		ConfigFactory.getClient.register('**', () => OxylinkApiConfig.ClientConfig);
		ConfigFactory.getGoogleMapApiKey.register('**', () =>
			getGoogleMapApiKey(OxylinkApiConfig.GoogleMapApiKeyConfig),
		);
		ConfigFactory.getLogsConfig.register('**', () =>
			getLogsConfig(OxylinkApiConfig.EsLogsConfig),
		);
	};
}
